import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActionMenuService } from './action-menu.service';

export interface ActionMenuOption {
  label: string;
  value: string;
  isDelete?: boolean;
  isArchive?: boolean;
  isDisabled?: boolean;
}

@Component({
  selector: 'ops-action-menu',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  template: `
    <div class="action-menu" [class.should-enable-only-comments-feature]="shouldEnableOnlyCommentsFeature" [id]="menuId" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
      <div 
        class="action-item"
        *ngFor="let option of options"
        [class.delete-item]="option.isDelete"
        [class.archive-item]="option.isArchive"
        [class.disabled]="option.isDisabled"
        (click)="onItemClick(option)"
      >
        {{ option.label | translate }}
      </div>
    </div>
  `,
  styleUrls: ['./action-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ActionMenuComponent implements OnInit, OnDestroy {
  @Input() menuId: string = '';
  @Input() shouldEnableOnlyCommentsFeature?: boolean = false;
  @Output() itemSelected = new EventEmitter<string>(); 
  closeTimeout: any = null; 
  options: ActionMenuOption[] = [];

  constructor(private actionMenuService: ActionMenuService) {}

  ngOnInit() {
    if (!this.menuId) {
      console.warn('ActionMenuComponent requires a menuId');
    }
    this.actionMenuService.menuState$.subscribe((state) => {
      if (state.has(this.menuId)) {
        this.options = state.get(this.menuId);
      }
    });
  }

  ngOnDestroy() {
    clearTimeout(this.closeTimeout);
  }

  onItemClick(option: ActionMenuOption) {
    if (option.isDisabled) {
      return;
    }
    
    this.itemSelected.emit(option.value);
    this.actionMenuService.closeActionMenu(this.menuId);
  }
  startCloseTimeout(waitingTime?: number) {
    clearTimeout(this.closeTimeout );

    const wTime = waitingTime || 200;

      this.closeTimeout = setTimeout(() => {
        this.actionMenuService.closeActionMenu(this.menuId);
      }, wTime);

  }

  onMouseEnter() {
    clearTimeout(this.closeTimeout);
  }

  onMouseLeave() {
    this.startCloseTimeout();
    
  }
} 